// Auth utilities for cross-browser compatibility
// Uses localStorage + Authorization headers instead of cookies
// This works reliably on Safari, Chrome, Firefox, Opera, etc.

const TOKEN_KEY = 'dmrg_admin_token';

export const authUtils = {
  // Store the session token
  setToken: (token) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    }
  },

  // Get the stored token
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  // Remove the token (logout)
  clearToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  // Get axios config with auth header
  getAuthConfig: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      return {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };
    }
    return {};
  },

  // Check if we have a token stored
  hasToken: () => {
    return !!localStorage.getItem(TOKEN_KEY);
  }
};

export default authUtils;
